import { render, staticRenderFns } from "./EditTextNumeros.vue?vue&type=template&id=158840d5&scoped=true"
import script from "./EditTextNumeros.vue?vue&type=script&lang=js"
export * from "./EditTextNumeros.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "158840d5",
  null
  
)

export default component.exports